import { IFormConfigResult } from "../services/contextService";
import IFormDefinition from "../interfaces/IFormDefinition";

const FormDefinitionMapper = {
    apiToDomain: (api: IFormConfigResult["lomakemaaritys"] | any, parse?: (data: string) => any): IFormDefinition => {
        let decoded
        const data = api.lomakemaaritys ? api.lomakemaaritys.data : api.data;
        if (data) {
            try {
                decoded = parse ? parse(data) : JSON.parse(atob(data))
            } catch (err) {
                console.log(err)
            }
        }

        return {
            id: api.id,
            name: api.nimi,
            category: api.kategoria,
            workflow: api.tyonkulku,
            schema: decoded
        }
    },
};

export default FormDefinitionMapper
